export default function isSafeClassName(className) {
  return className.indexOf('ad') === -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/fela/es/isSafeClassName.js
// module id = 1094
// module chunks = 0